export class BasePortal {

	async init() { }

	async load() { }

	async save(data, forceSave) { }
	
	async delete() { }

	gameStart() { }

	gameStop() { }

	loadStart() { }

	loadStop() { }

	get autoLogin() { }

	subscribeBot() { }

	createShortCut() { }

	async getInvite() { }

	async inviteSend(user, room) { }

	async findAndInvite(userFrom, room) { }

	async getFriends() { }

	tryShowInterstitialAd() { }
}
